export const scheduleTranslations: Record<string, string> = {
  'full-time': 'Vollzeit',
  'part-time': 'Teilzeit',
  'full- or part-time': 'Voll- oder Teilzeit',
  'full-or-part-time': 'Voll- oder Teilzeit',
};

export function formatScheduleOption(value: string): string {
  const normalized = value.trim().toLowerCase();
  const translated = scheduleTranslations[normalized];
  if (translated) {
    return translated;
  }
  return normalized
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
